const defaultMaraudersZone = {
  PACKBENCH: 'pack_bench',
  TRAFFIC: 'traffic',
};

module.exports = {
  defaultMaraudersZone,
};
